// Coding standard for this project defined @ https://github.com/MatthewSH/standards/blob/master/JavaScript.md
'use strict';

exports = module.exports = !!(typeof process !== 'undefined' && process.versions && process.versions.node);



//////////////////
// WEBPACK FOOTER
// ./~/is-node/index.js
// module id = 894
// module chunks = 0